import {WavesInit} from "./wavesOnPage";

export default class ChooseLocationGallery{

    constructor(opts){

        this.selectedCountry = null;
        this.selectedState = null;
        this.selectedCity = null;

        this.options = opts;

        console.log(opts);

        this.page       = null;
        this.countries  = [];
        this.states     = [];
        this.cities     = [];

        this.container = $('<div class="chooseLocationGallery">' +
            '<div class="chooseLocationGallery-header"></div>' +
            '<div class="chooseLocationGallery-body">' +
            '<div class="sliderLocations">' +
            '<div class="slideLocations countries">' +
            '<div class="slide-content custom-scrollbar overscroll-behavior-contain" style="max-height: 440px"></div>' +
            '</div>' +
            '<div class="slideLocations states">' +
            '<div class="slide-header">' +
            '<span class="back"><i class="icon-chevron-left"></i> Back</span>' +
            '</div>' +
            '<div class="slide-content custom-scrollbar overscroll-behavior-contain"></div>' +
            '</div>' +
            '<div class="slideLocations cities">' +
            '<div class="slide-header">' +
            '<span class="back"><i class="icon-chevron-left"></i> Back</span>' +
            '</div>' +
            '<div class="slide-content custom-scrollbar overscroll-behavior-contain"></div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>');

    }

    updateSelected(){

        let self = this;

        let payload = null;

        if(self.selectedCity) payload = self.selectedCity;
        else if(self.selectedState) payload = self.selectedState;
        else if(self.selectedCountry) payload = self.selectedCountry;

        $(document).trigger('ChooseLocationGallery.select', [payload]);

    }

    getCities(countryId, stateId, opts){

        let self = this;

        let data = {};

        data = Object.assign(data, opts);

        return new Promise(resolve => {

            if(self.cities[stateId] && self.cities[stateId].length > 0) resolve(self.cities[stateId]);

            data.country_id = countryId;
            data.state_id   = stateId;

            $.get('/ajax/getCities', data, function(d){
                let res = ParseResp(d);
                if(res.status === 'ok'){
                    self.cities[stateId] = res.data.items;
                    resolve(self.cities[stateId]);
                }
            })
        })

    }

    getStates(countryId, opts){

        let self = this;

        let data = {};

        data = Object.assign(data, opts);

        return new Promise(resolve => {

            if(self.states[countryId] && self.states[countryId].length > 0) resolve(self.states[countryId]);

            data.country_id = countryId;

            $.get('/ajax/getStates', data, function(d){
                let res = ParseResp(d);
                if(res.status === 'ok'){
                    self.states[countryId] = res.data.items;
                    resolve(self.states[countryId]);
                }
            })
        })

    }

    getCountries(opts){

        let data = {};

        data = Object.assign(data, opts);

        let self = this;

        return new Promise(resolve => {

            if(self.countries.length > 0) resolve(self.countries);

            $.get('/ajax/getCountries', data, function(d){
                let res = ParseResp(d);
                if(res.status === 'ok'){
                    self.countries = res.data.items;
                    resolve(self.countries);
                }
            })
        })
    }

    showCities(country, state){
        let self = this;

        self.container.find('.sliderLocations').css('transform', 'translateX(-66.666%)');
        self.container.find('.cities .slide-content').html(LoaderBox.render());

        self.container.find('.cities .back').off('click');
        self.container.find('.cities .back').on('click', function(){
            self.container.find('.sliderLocations').css('transform', 'translateX(-33.333%)');
            self.selectedState = null;
            self.selectedCity = null;
            self.updateSelected();
        })

        self.getCities(country.id, state.id, self.options).then(cities => {
            let list = $('<div class="listLocations"></div>');
            cities.forEach(city => {

                let count_text = '';

                if(self.options.withCountRoutes === true){
                    count_text = 'Route' + (city.count_routes > 1 ? 's' : '') + ': ' + city.count_routes
                }else if(self.options.withCountEvents === true){
                    count_text = 'Event' + (city.count_events > 1 ? 's' : '') + ': ' + city.count_events
                }

                let el = $('<div class="itemLocation flex-row flex-between align-items-center waves">' +
                    '<div class="flex-row gap_2 align-items-center">' +
                    '<i class="icon-event_place fs-24"></i>' +
                    '<div class="flex-col gap_1">' +
                    '<div class="fs-16">' + city.name + '</div>' +
                    '<div class="fs-14 color-d400">' + city.formated + '</div>' +
                    '<div class="fs-14 color-d400">' + count_text + '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>');
                list.append(el);
                el.on('click', function(){
                    self.selectedCity = {type: 'city', id: city.id, val: city.formated + ', ' + city.name, coordinates: city.coordinates};
                    setTimeout(function () {
                        self.updateSelected();
                    }, 200)
                })
            })
            self.container.find('.cities .slide-content').html(list);
            WavesInit();
        })

    }

    showStates(country){

        let self = this;

        self.container.find('.sliderLocations').css('transform', 'translateX(-33.333%)');
        self.container.find('.states .slide-content').html(LoaderBox.render());

        self.container.find('.states .back').off('click');
        self.container.find('.states .back').on('click', function(){
            self.container.find('.sliderLocations').css('transform', 'translateX(0)');
            self.selectedCountry = null;
            self.updateSelected();
        })

        self.getStates(country.id, self.options).then(states => {
            let list = $('<div class="listLocations"></div>');
            states.forEach(state => {

                let count_text = '';

                if(self.options.withCountRoutes === true){
                    count_text = 'Route' + (state.count_routes > 1 ? 's' : '') + ': ' + state.count_routes
                }else if(self.options.withCountEvents === true){
                    count_text = 'Event' + (state.count_events > 1 ? 's' : '') + ': ' + state.count_events
                }

                let el = $('<div class="itemLocation flex-row flex-between align-items-center waves">' +
                    '<div class="flex-row gap_2 align-items-center">' +
                    '<i class="icon-event_place fs-24"></i>' +
                    '<div class="flex-col gap_1">' +
                    '<div class="fs-16">' + state.name + '</div>' +
                    '<div class="fs-14 color-d400">' + count_text + '</div>' +
                    '</div>' +
                    '</div>' +
                    '<i class="icon-chevron-right"></i>' +
                    '</div>');
                list.append(el);
                el.on('click', function(){
                    self.selectedState = {type: 'state', id: state.id, val: state.formated};
                    self.updateSelected();

                    self.showCities(country, state);
                })
            })
            self.container.find('.states .slide-content').html(list);
            WavesInit();
        })


    }

    showCountries(){

        let self = this;

        self.container.find('.sliderLocations').css('transform', '0');
        self.container.find('.countries .slide-content').html(LoaderBox.render());

        this.getCountries(self.options).then(counties => {
            let list = $('<div class="listLocations"></div>')
            counties.forEach(country => {

                let count_text = '';

                if(self.options.withCountRoutes === true){
                    count_text = 'Route' + (country.count_routes > 1 ? 's' : '') + ': ' + country.count_routes
                }else if(self.options.withCountEvents === true){
                    count_text = 'Event' + (country.count_events > 1 ? 's' : '') + ': ' + country.count_events
                }

                let el = $('<div class="itemLocation flex-row flex-between align-items-center waves">' +
                    '<div class="flex-row gap_2 align-items-center">' +
                    '<i class="icon-event_place fs-24"></i>' +
                    '<div class="flex-col gap_1">' +
                    '<div class="fs-16">' + country.name + '</div>' +
                    '<div class="fs-14 color-d400">' + count_text + '</div>' +
                    '</div>' +
                    '</div>' +
                    '<i class="icon-chevron-right"></i>' +
                    '</div>');
                list.append(el);
                el.on('click', function(){

                    self.selectedCountry = {type: 'country', id: country.id, val: country.name};
                    self.updateSelected();

                    self.showStates(country);
                })
            })
            self.container.find('.countries .slide-content').html(list);
            WavesInit();
        })
    }

    render(){
        this.showCountries();
        return this.container;
    }

}